import { createFileRoute } from '@tanstack/react-router'
import { AuditorMyDashboard } from '@/components/auditor-center/AuditorCenterPage'

export const Route = createFileRoute('/(protected)/auditor-center/')({
  component: AuditorMyDashboard,
})
